import { useEffect, useState } from "react";

/**
 * Which headset the dock is driving. Falls to the most recently heard-from one
 * whenever the current pick is gone (or there is none yet), never overriding a
 * pick that is still in the list.
 */
export function useHeadsetSelection(headsetIds: string[]) {
  const [selectedHeadsetId, setSelectedHeadsetId] = useState<string | null>(null);

  useEffect(() => {
    if (!headsetIds.length) return;
    if (selectedHeadsetId && headsetIds.includes(selectedHeadsetId)) return;
    setSelectedHeadsetId(headsetIds[0]);
  }, [headsetIds, selectedHeadsetId]);

  return [selectedHeadsetId, setSelectedHeadsetId] as const;
}
